import { render, staticRenderFns } from "./RsaConfigurazioneAttivitaEditPage.vue?vue&type=template&id=4bd63518"
import script from "./RsaConfigurazioneAttivitaEditPage.vue?vue&type=script&lang=js"
export * from "./RsaConfigurazioneAttivitaEditPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports